const DebugLog = new class {
    log(message) {
        if (window.debug_mode) {
            console.log(message);
        }
    }
};

export default DebugLog;
